export default "__VITE_ASSET__9b927e59__"